module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0237.f5c7cec6.jpg";